import { ADD_PAYMENT_METHOD_SUCCESS } from '../constants'
import * as constants from './constants'

const initialState = {
    cardIsSuccessfullyAdded: null,
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PAYMENT_METHOD_SUCCESS:
            return { ...state, cardIsSuccessfullyAdded: true }
        case constants.ADD_CREDIT_CARD_FAILURE:
            return {
                ...state,
                cardIsSuccessfullyAdded: false,
            }
        case constants.ADD_CREDIT_CARD_RESET:
            return {
                ...state,
                cardIsSuccessfullyAdded: null,
            }
        default:
            return state
    }
}

export default reducer
